import { StoreActionType as Type } from '../../types';

const initialState: any = {
    region: JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId || 0,
};

export const regionReducer: any = (state: any = initialState, action: any) => {
    switch (action?.type) {
        case Type.SET_REGION:
            return {
                ...state,
                region: action?.payload?.region,
            };

        default:
            return state;
    }
};
